 /* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import authModule from './authModule.js'
export default new Vuex.Store({
    modules:{
        auth:authModule,
    }
})
